import { directusApi } from '@/api';
import { Data } from '@/models/data.model';
import { asyncForEach, formatNested, validateFileName } from '@/utils';
import lodash from 'lodash';
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list';
export interface ProductBrand {
    id?: number;
    slug: string;
    name: string;
    image?: any;
    cover?: any;
    img_product?: any;
    parent_id?: any;
}

export interface ProductBrandState {
    allProductBrands: Array<ProductBrand>;
    nestedProductBrands: Array<ProductBrand>;
    allProductBrandsLoading: boolean;

    activeProductBrand: ProductBrand | null;
    activeProductBrandLoading: boolean;
}

const state: ProductBrandState = {
    allProductBrands: [],
    nestedProductBrands: [],
    allProductBrandsLoading: false,

    activeProductBrand: {
        id: 0,
        slug: '',
        name: '',
        image: [],
        cover: [],
        img_product: [],
        parent_id: 0
    },
    activeProductBrandLoading: false
};

const defaultProductBrand = {
    id: 0,
    slug: '',
    name: '',
    image: null,
    cover: null,
    img_product: null,
    parent_id: 0
}

const mutations = {
    TOGGLE_ALL_BRANDS_LOADING(state: ProductBrandState, data: boolean) {
        state.allProductBrandsLoading = data;
    },
    SET_ALL_BRANDS(state: ProductBrandState, data: Array<ProductBrand>) {
        state.allProductBrands = data;
        state.nestedProductBrands = new Tree(
            formatNested(
                data.map(item => {
                    return {
                        ...item,
                        dragDisabled: true,
                        addTreeNodeDisabled: true,
                        addLeafNodeDisabled: true,
                        editNodeDisabled: false,
                        delNodeDisabled: false,
                    };
                }),
                'id',
                'parent_id'
            )
        );
    },
    TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING(state: ProductBrandState, data: boolean) {
        state.activeProductBrandLoading = data;
    },
    REMOVE_PRODUCT_BRAND(state: ProductBrandState, id: number) {
        state.allProductBrands = lodash.remove(state.allProductBrands, function (n) {
            return n.id != id;
        });
    },
    SET_ACTIVE_PRODUCT_BRAND(state: ProductBrandState, data: ProductBrand) {
        let image = data.image ? { id: data.image, url: `https://directus.prodelec.app/assets/${data.image}`, origin: 'directus' } : null;
        let cover = data.cover ? { id: data.cover, url: `https://directus.prodelec.app/assets/${data.cover}`, origin: 'directus' } : null;
        let img_product = data.img_product ? { id: data.img_product, url: `https://directus.prodelec.app/assets/${data.img_product}`, origin: 'directus' } : null;

        state.activeProductBrand = {
            ...data,
            image,
            cover,
            img_product
        };
    }
};

const actions = {
    async getAll({ _, commit }: any, data: Data | null) {
        let params = '';
        if (data) params += `&search=${data.search}`;
        params += '&limit=200&meta=total_count&sort=name';
        commit('TOGGLE_ALL_BRANDS_LOADING', true);
        await directusApi('GET', `items/products_brands?${params}`)
            .then(res => {
                commit('SET_ALL_BRANDS', res.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALL_BRANDS_LOADING', false);
            });
    },
    async getOne({ _, commit }: any, id: any | null = null) {
        commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', true);
        if (id) {
            await directusApi('GET', `items/products_brands/${id}`)
                .then(res => {
                    // console.log('brands ==> ', res.data.data);
                    commit('SET_ACTIVE_PRODUCT_BRAND', res.data.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', false);
                });
        } else {
            commit('SET_ACTIVE_PRODUCT_BRAND', defaultProductBrand);
            commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', false);
        }
    },
    async postOne({ _, commit, dispatch }: any, data: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', true);

        let brandEndpoint: string = 'items/products_brands';
        let brandMethod: any = 'POST';

        if (data.data.id != 0) {
            brandMethod = 'PATCH';
            brandEndpoint = `items/products_brands/${data.data.id}`;
        }

        await directusApi(brandMethod, brandEndpoint, {
            name: data.data.name,
            slug: data.data.slug,
            parent_id: data.parent_id
        })
            .then(async (brand: any) => {

                let image: any = {};
                data.data.image == '' ? image = null : image = brand.data.data.image;
                let complete_image = data.data.complete_image;

                let cover: any = {};
                data.data.cover == '' ? cover = null : cover = brand.data.data.cover;
                let complete_cover = data.data.complete_cover;

                let img_product: any = {};
                data.data.img_product == '' ? img_product = null : img_product = brand.data.data.img_product;
                let complete_img_product = data.data.complete_img_product;

                // ****** START img file process
                try {
                    if (data.data.image.origin == 'upload') {
                        let imageNameValidation = await validateFileName(data.data.image.name);
                        if (imageNameValidation == 0) {
                            console.log('uploading', data.data.image);
                            await directusApi('POST', `files`, data.data.image.file)
                                .then(async (resFile: any) => {
                                    image = [
                                        {
                                            id: resFile.data.data.id,
                                            sort: data.data.image.sort,
                                            url: `https://directus.prodelec.app/assets/${resFile.data.data.id}`,
                                            origin: 'directus',
                                            name: resFile.data.data.title,
                                            file: data.data.image.file
                                        }
                                    ];
                                    await asyncForEach(complete_image, async (complete_gallery_item, complete_gallery_index) => {
                                        console.log('posting rezising file image :D');
                                        if (complete_gallery_item.origin != 'directus') {
                                            await directusApi('POST', `files`, complete_gallery_item.file)
                                                .then(async (resFile: any) => {
                                                    if (data.data.image.hasOwnProperty('alt')) {
                                                        await directusApi('PATCH', `files/${resFile.data.data.id}`, { alt: data.data.image.alt })
                                                            .then(async (resFile: any) => {
                                                                console.log('Alt added to complete gallery');
                                                            })
                                                            .catch(err => {
                                                                console.log(err);
                                                            });
                                                    }
                                                    complete_image[complete_gallery_index] = { id: resFile.data.data.id, sort: null, name: resFile.data.data.title, origin: 'directus', alt: data.data.image.hasOwnProperty('alt') ? data.data.image.alt : '' };
                                                })
                                                .catch(err => {
                                                    console.log(err);
                                                });
                                        }
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        } else {
                            data.vm.$bvToast.toast(`Error al guardar, la imagen ${data.data.image.name} ya existe.`, {
                                title: `Imagen ya existente`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', false);
                            return false;
                        }
                    } else if (data.data.image.origin == 'directus-update') {
                        image = { id: data.data.image.id };
                        await directusApi('GET', `files/${data.data.image.id}`)
                            .then(async (resFile: any) => {
                                image = resFile.data.data;
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    } else {
                        if (data.data.image) {
                            await directusApi('GET', `files/${data.data.image.id}`)
                                .then(async (resFile: any) => {
                                    image = resFile.data.data;
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                    }
                } catch (error) {
                    console.log('error => no contiene una imagen');
                }
                // ****** END img file process

                // ****** START cover file process
                try {
                    if (data.data.cover.origin == 'upload') {
                        let coverNameValidation = await validateFileName(data.data.cover.name);
                        if (coverNameValidation == 0) {
                            await directusApi('POST', `files`, data.data.cover.file)
                                .then(async (resFile: any) => {
                                    cover = [
                                        {
                                            id: resFile.data.data.id,
                                            sort: data.data.cover.sort,
                                            url: `https://directus.prodelec.app/assets/${resFile.data.data.id}`,
                                            origin: 'directus',
                                            name: resFile.data.data.title,
                                            file: data.data.cover.file
                                        }
                                    ];
                                    await asyncForEach(complete_cover, async (complete_gallery_item, complete_gallery_index) => {
                                        console.log('posting rezising file :D');
                                        if (complete_gallery_item.origin != 'directus') {
                                            await directusApi('POST', `files`, complete_gallery_item.file)
                                                .then(async (resFile: any) => {
                                                    if (data.data.cover.hasOwnProperty('alt')) {
                                                        await directusApi('PATCH', `files/${resFile.data.data.id}`, { alt: data.data.cover.alt })
                                                            .then(async (resFile: any) => {
                                                                console.log('Alt added to complete gallery');
                                                            })
                                                            .catch(err => {
                                                                console.log(err);
                                                            });
                                                    }
                                                    complete_cover[complete_gallery_index] = { id: resFile.data.data.id, sort: null, name: resFile.data.data.title, origin: 'directus', alt: data.data.cover.hasOwnProperty('alt') ? data.data.cover.alt : '' };
                                                })
                                                .catch(err => {
                                                    console.log(err);
                                                });
                                        }
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        } else {
                            data.vm.$bvToast.toast(`Error al guardar, la imagen ${data.data.cover.name} ya existe.`, {
                                title: `Imagen ya existente`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', false);
                            return false;
                        }
                    } else if (data.data.cover.origin == 'directus-update') {
                        await directusApi('GET', `files/${data.data.cover.id}`)
                            .then(async (resFile: any) => {
                                cover = resFile.data.data;
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    } else {
                        if (data.data.cover) {
                            await directusApi('GET', `files/${data.data.cover.id}`)
                                .then(async (resFile: any) => {
                                    cover = resFile.data.data;
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                    }
                } catch (error) {
                    console.log('error => no contiene un cover');
                }
                // ****** END cover file process

                // ****** START img_product file process
                try {
                    if (data.data.img_product.origin == 'upload') {
                        let img_productNameValidation = await validateFileName(data.data.img_product.name);
                        if (img_productNameValidation == 0) {
                            await directusApi('POST', `files`, data.data.img_product.file)
                                .then(async (resFile: any) => {
                                    img_product = [
                                        {
                                            id: resFile.data.data.id,
                                            sort: data.data.img_product.sort,
                                            url: `https://directus.prodelec.app/assets/${resFile.data.data.id}`,
                                            origin: 'directus',
                                            name: resFile.data.data.title,
                                            file: data.data.img_product.file
                                        }
                                    ];
                                    await asyncForEach(complete_img_product, async (complete_gallery_item, complete_gallery_index) => {
                                        console.log('posting rezising file :D');
                                        if (complete_gallery_item.origin != 'directus') {
                                            await directusApi('POST', `files`, complete_gallery_item.file)
                                                .then(async (resFile: any) => {
                                                    if (data.data.img_product.hasOwnProperty('alt')) {
                                                        await directusApi('PATCH', `files/${resFile.data.data.id}`, { alt: data.data.img_product.alt })
                                                            .then(async (resFile: any) => {
                                                                console.log('Alt added to complete gallery');
                                                            })
                                                            .catch(err => {
                                                                console.log(err);
                                                            });
                                                    }
                                                    complete_img_product[complete_gallery_index] = { id: resFile.data.data.id, sort: null, name: resFile.data.data.title, origin: 'directus', alt: data.data.img_product.hasOwnProperty('alt') ? data.data.img_product.alt : '' };
                                                })
                                                .catch(err => {
                                                    console.log(err);
                                                });
                                        }
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        } else {
                            data.vm.$bvToast.toast(`Error al guardar, la imagen ${data.data.img_product.name} ya existe.`, {
                                title: `Imagen ya existente`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', false);
                            return false;
                        }
                    } else if (data.data.img_product.origin == 'directus-update') {
                        // img_product = { id: data.data.img_product.id };
                        await directusApi('GET', `files/${data.data.img_product.id}`)
                            .then(async (resFile: any) => {
                                img_product = resFile.data.data;
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    } else {
                        if (data.data.img_product) {
                            await directusApi('GET', `files/${data.data.img_product.id}`)
                                .then(async (resFile: any) => {
                                    img_product = resFile.data.data;
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                    }
                } catch (error) {
                    console.log('error => no contiene un img_product');
                }
                // ****** END img_product file process

                // ********************** START adding id of img to brand
                if (data.data.image && data.data.image.hasOwnProperty('alt') && data.data.image.origin != 'upload') {
                    await directusApi('PATCH', `files/${data.data.image.id}`, { alt: data.data.image.alt })
                        .then(async (resFile: any) => {
                            if (complete_image) {
                                await asyncForEach(complete_image, async (complete_gallery_item, complete_gallery_index) => {
                                    await directusApi('PATCH', `files/${complete_gallery_item.id}`, { alt: data.data.image.alt })
                                        .then(async (resFile: any) => {
                                            complete_image[complete_gallery_index] =
                                            {
                                                ...complete_image[complete_gallery_index],
                                                alt: data.data.image.alt
                                            }
                                        })
                                        .catch(err => {
                                            console.log(err);
                                        });
                                });
                                console.log('Alt updated in all gallery');

                            }
                            console.log('Alt updated succesfully');

                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                if (image) {
                    if (image.length > 0) {
                        image[0].hasOwnProperty('id') ? image[0] = image[0].id : image;
                    }
                    await directusApi('PATCH', `items/products_brands/${brand.data.data.id}`, { image: image[0], complete_image: complete_image })
                        .then(async (res: any) => {
                            console.log('image added/updated', res.data.data.image);
                            dispatch('getOne', brand.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                } else {
                    await directusApi('PATCH', `items/products_brands/${brand.data.data.id}`, { image: null, complete_image: '[]' })
                        .then(async (res: any) => {
                            console.log('image removed');
                            dispatch('getOne', brand.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                // ********************** END adding id of img to brand

                // ********************** START adding id of cover to brand
                if (data.data.cover && data.data.cover.hasOwnProperty('alt') && data.data.cover.origin != 'upload') {
                    await directusApi('PATCH', `files/${data.data.cover.id}`, { alt: data.data.cover.alt })
                        .then(async (resFile: any) => {
                            if (complete_cover) {
                                await asyncForEach(complete_cover, async (complete_gallery_item, complete_gallery_index) => {
                                    await directusApi('PATCH', `files/${complete_gallery_item.id}`, { alt: data.data.cover.alt })
                                        .then(async (resFile: any) => {
                                            complete_cover[complete_gallery_index] =
                                            {
                                                ...complete_cover[complete_gallery_index],
                                                alt: data.data.cover.alt
                                            }
                                        })
                                        .catch(err => {
                                            console.log(err);
                                        });
                                });
                                console.log('Alt updated in all gallery');

                            }
                            console.log('Alt updated succesfully');

                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                if (cover) {
                    if (cover.length > 0) {
                        cover[0].hasOwnProperty('id') ? cover[0] = cover[0].id : cover;
                    }
                    await directusApi('PATCH', `items/products_brands/${brand.data.data.id}`, { cover: cover[0], complete_cover: complete_cover })
                        .then(async (res: any) => {
                            console.log('cover added/updated', res.data.data.cover);
                            dispatch('getOne', brand.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                } else {
                    await directusApi('PATCH', `items/products_brands/${brand.data.data.id}`, { cover: null, complete_cover: '[]' })
                        .then(async (res: any) => {
                            console.log('cover removed');
                            dispatch('getOne', brand.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                // ********************** END adding id of cover to brand

                // ********************** START adding id of img_product to brand
                if (data.data.img_product && data.data.img_product.hasOwnProperty('alt') && data.data.img_product.origin != 'upload') {
                    await directusApi('PATCH', `files/${data.data.img_product.id}`, { alt: data.data.img_product.alt })
                        .then(async (resFile: any) => {
                            if (complete_img_product) {
                                await asyncForEach(complete_img_product, async (complete_gallery_item, complete_gallery_index) => {
                                    await directusApi('PATCH', `files/${complete_gallery_item.id}`, { alt: data.data.img_product.alt })
                                        .then(async (resFile: any) => {
                                            complete_img_product[complete_gallery_index] =
                                            {
                                                ...complete_img_product[complete_gallery_index],
                                                alt: data.data.img_product.alt
                                            }
                                        })
                                        .catch(err => {
                                            console.log(err);
                                        });
                                });
                                console.log('Alt updated in all gallery');

                            }
                            console.log('Alt updated succesfully');

                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                if (img_product) {
                    if (img_product.length > 0) {
                        img_product[0].hasOwnProperty('id') ? img_product[0] = img_product[0].id : img_product;
                    }
                    await directusApi('PATCH', `items/products_brands/${brand.data.data.id}`, { img_product: img_product[0], complete_img_product: complete_img_product })
                        .then(async (res: any) => {
                            console.log('img_product added/updated', res.data.data.img_product);
                            dispatch('getOne', brand.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                } else {
                    await directusApi('PATCH', `items/products_brands/${brand.data.data.id}`, { img_product: null, complete_img_product: '[]' })
                        .then(async (res: any) => {
                            console.log('img_product removed');
                            dispatch('getOne', brand.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                // await directusApi('PATCH', `items/products_brands/${brand.data.data.id}`, { img_product })
                //     .then(async (res: any) => {
                //         console.log('img_product added/updated', res.data.data.img_product);
                //     })
                //     .catch(err => {
                //         console.log(err);
                //     });
                // ********************** END adding id of img_product to brand

                dispatch('getOne', brand.data.data.id);
                data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                    title: `Obteniendo información`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });

                commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', false);
                dispatch("getAll");
                commit('SET_ACTIVE_PRODUCT_BRAND', brand.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', false);
            });
    },
    async deleteOne({ _, commit, dispatch }: any, data: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', true);
        await directusApi('DELETE', `items/products_brands/${data.id}`, {})
            .then(async (res: any) => {
                data.vm.$bvToast.toast('Se ha eliminado exitosamente', {
                    title: `Marca eliminada`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
                commit('REMOVE_PRODUCT_BRAND', data.id);
                dispatch('getAll');
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ACTIVE_PRODUCT_BRAND_LOADING', false);
            });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
